import { render } from "./MobileEditor.vue?vue&type=template&id=3f4ba656&scoped=true&ts=true"
import script from "./MobileEditor.vue?vue&type=script&lang=ts"
export * from "./MobileEditor.vue?vue&type=script&lang=ts"

import "./MobileEditor.vue?vue&type=style&index=0&id=3f4ba656&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4ba656"]])

export default __exports__